<sepidz-review class="review">
  <div review-filters>
    <div>
      <section style="margin-top: 2px">
        <sepidz-static-select-review
          valueType="boolean"
          [form]="formGroup"
          title="نمایش مانده درخط"
          name="ShowRunningTotal"
          key="ShowRunningTotal"
          [items]="[{ Name: 'نمایش مانده درخط', Value: true }]">
        </sepidz-static-select-review>
      </section>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FilterInfo')">
          <span>{{ "ClientApp.BackOffice.TRS.TreasuryReview.FilterInfo" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'FilterInfo'"></i>
        </div>
        <div *ngIf="selected === 'FilterInfo'">
          <section style="margin-top: 5px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.TRS.TreasuryReview.SlaveNo' | translate"
              name="SlaveNo"
              key="SlaveNo"
              [items]="[{ Name: translate('ClientApp.BackOffice.TRS.TreasuryReview.SlaveNo') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              [form]="formGroup"
              valueType="boolean"
              [title]="'ClientApp.BackOffice.TRS.TreasuryReview.ShowBeginingOfTheCoursResidue' | translate"
              name="ShowBeginingOfTheCoursResidue"
              key="ShowBeginingOfTheCoursResidue"
              [items]="[{ Name: translate('ClientApp.BackOffice.TRS.TreasuryReview.ShowBeginingOfTheCoursResidue'), Value: true }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              [form]="formGroup"
              valueType="boolean"
              [title]="'ClientApp.BackOffice.TRS.TreasuryReview.IsEstablishment' | translate"
              name="IsEstablishment"
              key="IsEstablishment"
              [items]="[{ Name: translate('ClientApp.BackOffice.TRS.TreasuryReview.IsEstablishment'), Value: true }]">
            </sepidz-static-select-review>
          </section>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('StatusKindTitle')">
          <span>{{ "ClientApp.BackOffice.TRS.StatusKind.StatusKindTitle" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'StatusKindTitle'"></i>
        </div>
        <div *ngIf="selected === 'StatusKindTitle'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.TRS.StatusKind.StatusKindTitle' | translate"
            [form]="formGroup"
            name="StatusKind"
            key="StatusKindIds"
            apiName="Lookup"
            systemName="TRS"
            category="StatusKind">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span>{{ "ClientApp.BackOffice.TRS.TreasuryReview.Branch" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.TRS.TreasuryReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('TrsConcern')">
          <span>{{ "ClientApp.BackOffice.TRS.TreasuryReview.TrsConcern" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'TrsConcern'"></i>
        </div>
        <div *ngIf="selected === 'TrsConcern'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.TRS.TreasuryReview.TrsConcern' | translate"
            [form]="formGroup"
            name="TrsConcern"
            key="TrsConcernIds"
            apiName="TrsConcern/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title">
          <span (click)="setSelectedFilter('OperationKind')"> {{ "ClientApp.BackOffice.TRS.TreasuryReview.OperationKind" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'OperationKind'"></i>
        </div>
        <div *ngIf="selected === 'OperationKind'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.TRS.TreasuryReview.OperationKind' | translate"
            [form]="formGroup"
            name="OperationKind"
            key="OperationKindIds"
            apiName="Lookup"
            systemName="TRS"
            category="OperationKind">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DocumentKind')">
          <span>{{ "ClientApp.BackOffice.TRS.TreasuryReview.DocumentKind" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DocumentKind'"></i>
        </div>
        <div *ngIf="selected === 'DocumentKind'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.TRS.TreasuryReview.DocumentKind' | translate"
            [form]="formGroup"
            name="DocumentKind"
            key="DocumentKindIds"
            apiName="Lookup"
            systemName="TRS"
            category="DocumentKind">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetTrsVoucherKind', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.TrsVoucherKind' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.TrsVoucherKind' | translate)"
          name="TrsVoucherKindId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.TrsVoucherKind' | translate"
          apiName="TreasuryReview/GetTrsVoucherKind"
          areaName="Treasury"
          [groupable]="false"
          [columns]="GetTrsVoucherKindColumns"
          [filtering]="true"
          pathPreFix="TRS"
          displayNameColumn="VoucherKindTitle"
          key="TrsVoucherKindIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetVoucherHeader', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.VoucherHeader' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.VoucherHeader' | translate)"
          name="TrsVoucherHeaderId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.VoucherHeader' | translate"
          apiName="TreasuryReview/GetVoucherHeader"
          areaName="Treasury"
          [columns]="GetVoucherHeaderColumns"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="TRS"
          displayNameColumn="VoucherNo"
          key="VoucherHeaderIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetVoucherDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.VoucherDetail' | translate">
        <sepidz-grid-review
          *ngIf="
            isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.VoucherDetail' | translate) &&
            GetVoucherDetailColumns &&
            GetVoucherDetailColumns.length > 0
          "
          name="VoucherDetail"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.VoucherDetail' | translate"
          apiName="TreasuryReview/GetVoucherDetail"
          areaName="Treasury"
          [columns]="GetVoucherDetailColumns"
          [selective]="true"
          [filtering]="true"
          [isModal]="false"
          pathPreFix="TRS"
          [actionTregger]="onActionClick"
          [actions]="actions"
          displayNameColumn="VoucherNo"
          key="VoucherDetailIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetReceivingChecksDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.ReceivingChecksDetail' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.ReceivingChecksDetail' | translate)"
          name="ReceivingChecksDetailId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.ReceivingChecksDetail' | translate"
          apiName="TreasuryReview/GetReceivingChecksDetail"
          areaName="Treasury"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          pathPreFix="TRS"
          [groupable]="true">
        </sepidz-grid-review>
      </ssg-tab>

      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetPayableChecksDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.PayableChecksDetail' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.PayableChecksDetail' | translate)"
          name="PayableChecksDetailId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.PayableChecksDetail' | translate"
          apiName="TreasuryReview/GetPayableChecksDetail"
          areaName="Treasury"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          pathPreFix="TRS"
          [groupable]="true">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetReceivableChecksDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.ReceivableChecksDetail' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.ReceivableChecksDetail' | translate)"
          name="ReceivableChecksDetailId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.ReceivableChecksDetail' | translate"
          apiName="TreasuryReview/GetReceivableChecksDetail"
          areaName="Treasury"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          pathPreFix="TRS"
          [groupable]="true">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetTreasuryDetailLedger', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.TreasuryDetailLedger' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.TreasuryDetailLedger' | translate)"
          name="TreasuryDetailLedgerId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.TreasuryDetailLedger' | translate"
          apiName="TreasuryReview/GetTreasuryDetailLedger"
          areaName="Treasury"
          [columns]="GetTreasuryDetailLedgerColumns"
          [filtering]="true"
          pathPreFix="TRS"
          displayNameColumn="TreasuryDetailLedgerTitle"
          key="BankAccountId">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab *hasPermission="['Treasury:TreasuryReview/GetCash', 'Same']" [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.Cash' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.Cash' | translate)"
          name="CashId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.Cash' | translate"
          apiName="TreasuryReview/GetCash"
          areaName="Treasury"
          [columns]="GetCashColumns"
          [filtering]="true"
          [groupable]="false"
          pathPreFix="TRS"
          displayNameColumn="CashTitle"
          key="CashIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetDetailLedger', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.DetailLedger' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.DetailLedger' | translate)"
          name="DetailLedgerId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.DetailLedger' | translate"
          apiName="TreasuryReview/GetDetailLedger"
          areaName="Treasury"
          [groupable]="false"
          [columns]="GetDetailLedgerColumns"
          [filtering]="true"
          pathPreFix="TRS"
          displayNameColumn="DetailLedgerCode"
          key="DetailLedgerIds">
        </sepidz-grid-review>
      </ssg-tab>

      <ssg-tab
        *hasPermission="['Treasury:TreasuryReview/GetTreasuryHistory', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.TRS.TreasuryReview.TreasuryHistory' | translate">
        <sepidz-grid-review
          *ngIf="
            isActveTab('ClientApp.BackOffice.TRS.TreasuryReview.TreasuryHistory' | translate) &&
            GetVoucherDetailColumns &&
            GetVoucherDetailColumns.length > 0
          "
          name="TreasuryHistoryId"
          [title]="'ClientApp.BackOffice.TRS.TreasuryReview.TreasuryHistory' | translate"
          apiName="TreasuryReview/GetTreasuryHistory"
          areaName="Treasury"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          [isModal]="false"
          pathPreFix="TRS"
          [actionTregger]="onActionClick"
          [actions]="actions">
        </sepidz-grid-review>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
